var GenIcon = require('../lib').GenIcon

module.exports = function (props) {
   return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 20 20","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M4 18h12V6h-4V2H4v16zm-2 1V0h12l4 4v16H2v-1z"}}]})(props);
};
